import { useState } from "react";
import type { Client, ClientType } from "@ascente/shared-types";

interface Props {
  onAdd: (draft: Omit<Client, "id" | "color">) => void;
  onClose: () => void;
}

export function AddClientModal({ onAdd, onClose }: Props) {
  const [name, setName] = useState("");
  const [type, setType] = useState<ClientType>("hourly");
  const [rate, setRate] = useState("");
  const [email, setEmail] = useState("");

  const handleAdd = () => {
    if (!name) return;
    onAdd({ name, type, rate: parseFloat(rate) || 0, email, fixedFees: [], status: "active" });
  };

  const showRate = type === "hourly" || type === "hourly_fixed";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-title">Add Client</h3>

        <div className="form-group">
          <label className="inp-label">Client Name</label>
          <input className="inp" placeholder="e.g. Acme Corp" autoFocus value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleAdd()} />
        </div>

        <div className="form-group">
          <label className="inp-label">Email (optional)</label>
          <input className="inp" type="email" placeholder="client@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="inp-label">Billing Type</label>
            <select className="sel" value={type} onChange={(e) => setType(e.target.value as ClientType)}>
              <option value="hourly">Hourly</option>
              <option value="hourly_fixed">Hourly + Fixed</option>
              <option value="per_task_fixed">Per Task + Fixed</option>
              <option value="fixed_quarterly">Fixed Quarterly</option>
            </select>
          </div>
          {showRate && (
            <div className="form-group">
              <label className="inp-label">Hourly Rate ($)</label>
              <input type="number" className="inp" placeholder="0" min="0" step="0.01" value={rate} onChange={(e) => setRate(e.target.value)} />
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleAdd} disabled={!name}>Add Client</button>
        </div>
      </div>
    </div>
  );
}
